import moment from "moment";

import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Combobox, ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { ComboBoxControl } from "@/Common/Components/Inputs/ComboboxControl";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { TextAreaResizable } from "@/Common/Components/Inputs/TextAreaResizable";
import { Popup } from "@/Common/Components/Modals/Popup";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { MedicationHelper } from "@/Patient/Helpers/MedicationHelper";
import { MedicalItemMedicationAndPrescription } from "@/Patient/Models/MedicalSummary/MedicalItemMedicationAndPrescription";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";
import { PatientPrescriptionAdjustMedicationPopupModel } from "@/Patient/Models/PatientPrescriptionAdjustMedicationPopupModel";
import { MedicationSearchListItem } from "./SearchMedication";
import { SearchMedicationContainer } from "./SearchMedicationContainer";

import styles from "./PatientPrescriptionAdjustMedicationPopup.module.scss";

interface IPatientPrescriptionAdjustMedicationPopupProps {
    MedicationBeingAdjusted: MedicationModel;
    DefaultSelectedCode: string;
    onClosePopup: () => void;
    onSavePopup: (prescriptionAdjustMedicationPopupModel: PatientPrescriptionAdjustMedicationPopupModel) => void;
    manageOverlay?: boolean;
    defaultDiscontinueReason: string;
}

class PatientPrescriptionAdjustMedicationPopupState {
    public isSearchingMed: boolean;
    public baseMed: MedicationModel;
    public newMed: MedicationModel;
    public isSearchingMedEventId: string;
    public SelectedCode: string;
    public CeaseDate: Date;
    public CeaseReason: string;
    public StatusList: Immutable.List<ComboBoxDropDownItem>;
    public discontinueReasonList: Immutable.List<ComboBoxDropDownItem>;
    public selectedDiscontinueReason: string;
    public isInterruptingMed: boolean;
}

class PatientPrescriptionAdjustMedicationPopup extends React.Component<IPatientPrescriptionAdjustMedicationPopupProps, PatientPrescriptionAdjustMedicationPopupState> {
    public render(): JSX.Element {
        var self = this;
        var MedicationBeingAdjusted: MedicationModel = this.state.baseMed;
        var SelectedCode = this.state.SelectedCode;
        var selectedDiscontinueReason = this.state.selectedDiscontinueReason;

        const isSearchingMedName = MedicalItemMedicationAndPrescription.getSearchingMedicationName(MedicationBeingAdjusted.Model);

        return (
            <Popup
                cssClass="double-booking"
                title={cacheStore.GetString("ModifyLabel")}
                onCloseDelegate={() => this.props.onClosePopup()}
                manageOverlay={this.props.manageOverlay}
            >
                <div style={{ "overflowY": "auto", "paddingBottom": "50px" }}>
                    <div className="flex-container meds" style={{ "marginBottom": "0px", "marginTop": "10px" }}>
                        <div className="label" style={{ "paddingRight": "3px" }}>
                            <span>{cacheStore.GetString("ActionLabel")}</span>
                        </div>
                        <div>
                            <Combobox
                                id="_actionCombobox"
                                dataCy="patientPrescriptionAdjustMedication-action"
                                items={this.state.StatusList}
                                selectedCode={SelectedCode}
                                onChange={(newStateCode: string) => {
                                    this.MutateState((s: PatientPrescriptionAdjustMedicationPopupState) => {
                                        s.SelectedCode = newStateCode;
                                        if (MedicationHelper.isMeidcationReplaced(newStateCode)) {
                                            s.isSearchingMed = true;
                                            s.isSearchingMedEventId = GuidHelper.NewGuid();
                                        }
                                        else {
                                            s.isSearchingMed = false;
                                        }
                                        s.isInterruptingMed = MedicationHelper.isMedicationInterrupted(newStateCode);
                                    });
                                }}
                            />
                        </div>
                    </div>

                    <div className="flex-container meds" style={{ "marginBottom": "0px", "marginTop": "10px" }}>
                        <div className="label" style={{ "paddingRight": "3px" }} />

                        <div className="editablecell" style={{ width: "350px", "marginBottom": "4px" }}>
                            <div className="flex-container meds" style={{ justifyContent: "flex-start" }}>
                                <SearchMedicationContainer
                                    selectedCode={this.state.SelectedCode}
                                    isSearchingMedication={this.state.isSearchingMed}
                                    newMedication={this.state.newMed}
                                    searchingMedicationName={isSearchingMedName}
                                    searchingMedicationEventId={this.state.isSearchingMedEventId}
                                    onItemSelect={(response: MedicationSearchListItem): void => {
                                        const self = this;
                                        this.MutateState((s: PatientPrescriptionAdjustMedicationPopupState) => {
                                            const cloneBase = MedicationModel.getSearchedMedicationItem(self.state.baseMed, response);

                                            s.isSearchingMed = false;
                                            s.newMed = cloneBase;
                                        });
                                    }}
                                    onBlur={(customMedictionName: string): void => {
                                        const self = this;
                                        this.MutateState((s: PatientPrescriptionAdjustMedicationPopupState) => {
                                            if (self.state.newMed) {
                                                if (customMedictionName != null && customMedictionName != "") {
                                                    s.isSearchingMed = true;
                                                }
                                                const MedToUpdate = self.state.newMed;
                                                MedToUpdate.Model.Name = customMedictionName;
                                                const CloneBase = self.state.baseMed.Clone(true, true);

                                                if (CloneBase) {
                                                    CloneBase.ClearIdentificationFields();
                                                    CloneBase.Model.IsPast = false; // Is a prescription
                                                    CloneBase.Model.OriginalMedicationId = self.state.baseMed.Model.Id;
                                                    s.newMed = CloneBase;
                                                }
                                                else {
                                                    MedToUpdate.ClearIdentificationFields();
                                                    s.newMed = MedToUpdate;
                                                }
                                            }
                                        });
                                    }}
                                    onDeleteClick={(): void => {
                                        this.MutateState((s: PatientPrescriptionAdjustMedicationPopupState) => {
                                            const clone = MedicationModel.clearSearchedMedication(self.state.newMed);

                                            s.newMed = clone;
                                            s.isSearchingMed = true;
                                            s.isSearchingMedEventId = GuidHelper.NewGuid();
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {cacheStore.ClinicSettings.EnableMedicationDiscontinueReason && this.state.isInterruptingMed
                        ? (
                            <>
                                <div className={`flex-container meds ${styles.discontinueReason}`} style={{ "marginTop": "10px" }}>
                                    <div className="label" style={{ "paddingRight": "3px" }}>
                                        <span>{cacheStore.GetString("ReasonLabel")}</span>
                                    </div>
                                    <div style={{ "width": "400px" }}>
                                        <ComboBoxControl
                                            id="_discontinueReasonCombobox"
                                            items={this.state.discontinueReasonList}
                                            selectedCode={selectedDiscontinueReason}
                                            onChange={(newCode: string) => {
                                                this.MutateState((s: PatientPrescriptionAdjustMedicationPopupState) => {
                                                    s.selectedDiscontinueReason = newCode;
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="flex-container meds" style={{ "marginBottom": "0px" }}>
                                    <div className="label" style={{ "paddingRight": "3px" }}>
                                        <span />
                                    </div>
                                    <div style={{ "width": "400px" }}>
                                        <TextAreaResizable
                                            id="_ceaseReason"
                                            isDisabled={false}
                                            resetTextOnIdChange={false}
                                            text={this.state.CeaseReason}
                                            onChange={value => this.MutateState((s: PatientPrescriptionAdjustMedicationPopupState) => s.CeaseReason = value)}
                                        />
                                    </div>
                                </div>
                            </>
                        )
                        : (
                            <div className="flex-container meds" style={{ "alignItems": "flex-start", "marginBottom": "0px", "marginTop": "10px" }}>
                                <div className="label" style={{ "paddingRight": "3px" }}>
                                    <span>{cacheStore.GetString("ReasonLabel")}</span>
                                </div>
                                <div style={{ "width": "400px" }}>
                                    <TextAreaResizable
                                        id="_ceaseReason"
                                        isDisabled={false}
                                        resetTextOnIdChange={false}
                                        text={this.state.CeaseReason}
                                        onChange={value => this.MutateState((s: PatientPrescriptionAdjustMedicationPopupState) => s.CeaseReason = value)}
                                    />
                                </div>
                            </div>
                        )
                    }

                    <div className="flex-container meds" style={{ "marginBottom": "0px", "marginTop": "10px" }}>
                        <div className="label" style={{ "marginTop": "6px", "paddingRight": "3px" }}>
                            <span>{cacheStore.GetString("EndDateDLabel")}</span>
                        </div>
                        <div><DateSelector
                            id="_ceasedate"
                            date={this.state.CeaseDate}
                            dateFormat="yyyy/MM/dd"
                            disabled={false}
                            toDayEnabled={false}
                            onChangeCallback={(value: Date) => { this.MutateState((s: PatientPrescriptionAdjustMedicationPopupState) => { s.CeaseDate = value; }); }}
                        />
                        </div>
                    </div>
                </div>

                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <ButtonControl
                                    onClick={() => this.props.onClosePopup()}
                                    className="btn btn-default push-right-5"
                                    label={cacheStore.GetString("CancelLabel")}
                                />
                                <ButtonControl
                                    disabled={this.state.isSearchingMed}
                                    dataCy="patientPrescriptionAdjustMedication-continue"
                                    onClick={() => this.props.onSavePopup(new PatientPrescriptionAdjustMedicationPopupModel({
                                        baseMed: this.state.baseMed,
                                        newMed: this.state.newMed,
                                        selectedCode: this.state.SelectedCode,
                                        ceaseDate: this.state.CeaseDate,
                                        ceaseReason: this.state.CeaseReason,
                                        discontinueReasonLookupId: cacheStore.ClinicSettings.EnableMedicationDiscontinueReason && this.state.isInterruptingMed ? this.state.selectedDiscontinueReason : null
                                    }))}
                                    className="btn btn-primary"
                                    label={cacheStore.GetString("ContinueLabel")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    public MutateState(mutation: (state: PatientPrescriptionAdjustMedicationPopupState) => void): void {
        var s = new PatientPrescriptionAdjustMedicationPopupState();
        mutation(s);
        this.setState(s);
    }

    public componentWillMount(): void {
        var state = new PatientPrescriptionAdjustMedicationPopupState();
        state.StatusList = Immutable.List(MedicationModel.getMedicationStatusList(false));
        state.SelectedCode = this.props.DefaultSelectedCode;
        state.CeaseDate = moment(Date.now()).toDate();
        state.baseMed = this.props.MedicationBeingAdjusted;
        if (MedicationHelper.isMeidcationReplaced(this.props.DefaultSelectedCode)) {
            state.isSearchingMed = true;
            state.isSearchingMedEventId = GuidHelper.NewGuid();
        }
        state.discontinueReasonList = Immutable.List(MedicationModel.getDiscontinueReasonList());
        state.selectedDiscontinueReason = this.props.defaultDiscontinueReason;
        if (MedicationHelper.isMedicationInterrupted(this.props.DefaultSelectedCode)) {
            state.isInterruptingMed = true;
        }

        this.setState(state);
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }
}

export { PatientPrescriptionAdjustMedicationPopup, PatientPrescriptionAdjustMedicationPopupState };
